import Flex from '@Components/Bases/Flex';
import FormTextAreaAutoSize from '@Components/Form/FormTextAreaAutosize';
import { disabledTextAreaInputStyles } from '@Components/Form/styles';
import { InputLabel } from '@mui/material';
import { IGreenhouseFormValues } from '@Router/EsgGreenhouse/Containers/EsgGreenhouseFormProvider/types';
import { Control, useFormContext, useWatch } from 'react-hook-form';

type RolesAndResponsibilitiesProps = {
  control: Control<IGreenhouseFormValues, unknown>;
};

const RolesAndResponsibilities = ({
  control,
}: RolesAndResponsibilitiesProps) => {
  const completedSection = useWatch({
    name: 'climateChangeStructure.completedSection',
    control,
  });

  const { watch } = useFormContext();
  const subcommitteeType = watch('subcommitteeType');
  const isSubcommitteeTypeEmpty = subcommitteeType === '';

  const { isCompletedTh = false, isCompletedEn = false } =
    completedSection ?? {};

  return (
    <Flex>
      <InputLabel
        required
        sx={{
          textAlign: 'end',
          paddingLeft: 6,
          marginRight: 2,
          width: 1,
          maxWidth: 230,
          lineHeight: '1.5',
          whiteSpace: 'pre-wrap',
        }}
      >
        ขอบเขต อำนาจ หน้าที่ และบทบาทความรับผิดชอบ
      </InputLabel>
      <Flex gap={1} width={1} minWidth={600}>
        <FormTextAreaAutoSize
          name="responsibilitiesTh"
          inputProps={{
            placeholder: 'กรุณาระบุขอบเขต อำนาจ หน้าที่ และบทบาท ความรับผิดชอบ',
            minRows: 3,
            readOnly: isCompletedTh,
            tabIndex: isCompletedTh ? -1 : undefined,
          }}
          sx={
            isCompletedTh || isSubcommitteeTypeEmpty
              ? disabledTextAreaInputStyles
              : {}
          }
          flex={1}
          minWidth={200}
        />
        <FormTextAreaAutoSize
          name="responsibilitiesEn"
          inputProps={{
            placeholder: 'กรุณาระบุขอบเขต อำนาจ หน้าที่ และบทบาท ความรับผิดชอบ',
            minRows: 3,
            readOnly: isCompletedEn,
            tabIndex: isCompletedEn ? -1 : undefined,
          }}
          sx={
            isCompletedEn || isSubcommitteeTypeEmpty
              ? disabledTextAreaInputStyles
              : {}
          }
          flex={1}
          minWidth={200}
        />
      </Flex>
    </Flex>
  );
};

export default RolesAndResponsibilities;
